import _ from "lodash";
import moment from "moment";
import ModelDescriptions from "../../constants/modelDescriptions";
import Directions from "../../constants/directions";

const getPlotlineSeries = (plotline, axis) => {
  return {
    color: plotline.color,
    name: plotline.id,
    dashStyle: plotline.dashStyle,
    marker: {
      enabled: false
    },
    events: {
      legendItemClick: function(e) {
        if (this.visible) {
          this.chart[axis][0].removePlotLine(plotline.id);
        } else {
          this.chart[axis][0].addPlotLine(plotline);
        }
      }
    }
  };
};

const estimatePlotLine = {
  value: 0,
  width: 3,
  color: "black",
  dashStyle: "dot",
  id: "expected",
  zIndex: 10
};

const baseConfiguration = model => ({
  chart: {
    type: "line",
    zoomType: "x"
  },
  title: {
    text: model.venueName
  },
  xAxis: {
    type: "datetime"
  },
  yAxis: {
    title: ""
  },
  plotOptions: {
    line: {
      marker: {
        radius: 0
      }
    }
  }
});

export const BinomialConfiguration = model =>
  _.merge({}, baseConfiguration(model), {
    modelDescription: ModelDescriptions.BINOMIAL,
    subtitle: {
      text: `Binomial Test - ${directionLabel(model.direction)} Strike Zone`
    },
    series: getSeries(
      [
        {
          property: "upperBound",
          name: "upper bound",
          color: "lightblue",
          lineWidth: 2
        },
        {
          property: "lowerBound",
          name: "lower bound",
          color: "lightblue",
          lineWidth: 2
        },
        {
          property: "venueStrikeRate",
          name: "venue strike rate",
          color: "darkblue",
          lineWidth: 3
        },
        {
          property: "leagueAverage",
          name: "league average",
          color: "green",
          dashStyle: "Dot",
          lineWidth: 2
        }
      ],
      model.records
    )
  });

export const LogisticConfiguration = model => {
  return _.merge({}, baseConfiguration(model), {
    modelDescription: ModelDescriptions.LOGISTIC,
    subtitle: {
      text: `Logistic Regression - ${directionLabel(
        model.direction
      )} Strike Zone`
    },
    yAxis: {
      title: "",
      floor: -1,
      ceiling: 1,
      plotLines: [estimatePlotLine]
    },
    series: _.concat(
      getSeries(
        [
          {
            property: "upperBound",
            name: "upper bound",
            color: "lightblue",
            lineWidth: 2
          },
          {
            property: "lowerBound",
            name: "lower bound",
            color: "lightblue",
            lineWidth: 2
          },
          {
            property: "estimate",
            name: "estimate",
            color: "darkblue",
            lineWidth: 3
          }
        ],
        model.records
      ),
      getPlotlineSeries(estimatePlotLine, "yAxis")
    )
  });
};

export const MixedModelConfiguration = model =>
  _.merge({}, baseConfiguration(model), {
    modelDescription: ModelDescriptions.MIXED_MODEL,
    subtitle: {
      text: `Mixed Effects - ${directionLabel(model.direction)} Strike Zone`
    },
    yAxis: {
      plotLines: [estimatePlotLine]
    },
    series: _.concat(
      getSeries(
        [
          {
            property: "upperBound",
            name: "upper bound",
            color: "lightblue",
            lineWidth: 2
          },
          {
            property: "lowerBound",
            name: "lower bound",
            color: "lightblue",
            lineWidth: 2
          },
          {
            property: "estimate",
            name: "estimate",
            color: "darkblue",
            lineWidth: 3
          },
          {
            property: "estimatePercentile",
            name: "estimate percentile",
            color: "red",
            lineWidth: 2
          }
        ],
        model.records
      ),
      getPlotlineSeries(estimatePlotLine, "yAxis")
    )
  });

const getSeries = (seriesConfigurations, data) => {
  return seriesConfigurations.map(series => {
    const seriesData = data.map(record => {
      const epoch = moment(record.date).valueOf();

      return [epoch, record[series.property]];
    });
    return {
      name: series.name,
      color: series.color,
      data: seriesData,
      dashStyle: series.dashStyle,
      lineWidth: series.lineWidth
    };
  });
};

const directionLabel = direction => {
  switch (direction) {
    case Directions.EAST:
      return "1B";
    case Directions.WEST:
      return "3B";
    case Directions.NORTH:
      return "Top of";
    case Directions.SOUTH:
      return "Bottom of";
    default:
      return "";
  }
};



// WEBPACK FOOTER //
// ./src/components/charts/ModelBasedAlertingConfigs.js